import { render } from "./OptionEditor.vue?vue&type=template&id=1569c9f5&scoped=true"
import script from "./OptionEditor.vue?vue&type=script&lang=js"
export * from "./OptionEditor.vue?vue&type=script&lang=js"

import "./OptionEditor.vue?vue&type=style&index=0&id=1569c9f5&scoped=true&lang=css"

import exportComponent from "/home/tewky/cloverhitch/pelican/pelican-managers-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1569c9f5"]])

export default __exports__